import React from 'react';

export default function ImageGallery() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="27" viewBox="0 0 36 27" fill="none">
      <rect x="0.75" y="0.75" width="34.5" height="25.5" rx="3.5" stroke="#333333" strokeWidth="1.5" />
      <circle cx="6.75" cy="6.75" r="3" stroke="#333333" strokeWidth="1.5" />
      <path
        d="M33 16.0879V23.25H3V19.8955L9.85449 15.1982L13.6729 18.5625L14.1328 18.9678L14.6211 18.5986L26.0508 9.9668L33 16.0879Z"
        stroke="#333333"
        strokeWidth="1.5"
      />
    </svg>
  );
}
